import ProductProvider from './productProvider';

export const getProductByIdAsync = ProductProvider.getProductByIdAsync;

export const UpdateProductDtoAsync = ProductProvider.UpdateProductDtoAsync;

export const getPaginatedProductPreviewsAsync = ProductProvider.getPaginatedProductPreviewsAsync;

export const insertProductWithImageAsync = ProductProvider.insertProductWithImageAsync;

export const updateProductWithImageAsync = ProductProvider.updateProductWithImageAsync;
